import { render, staticRenderFns } from "./itemComponent.vue?vue&type=template&id=8239307a&scoped=true"
import script from "./itemComponent.vue?vue&type=script&lang=js"
export * from "./itemComponent.vue?vue&type=script&lang=js"
import style0 from "./itemComponent.vue?vue&type=style&index=0&id=8239307a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8239307a",
  null
  
)

export default component.exports